import './publicPath'

const Vue = window.Vue
Vue.component('qr-button', () => import('./QRCodeButton.vue'))
